import { render } from "./star-open.vue?vue&type=template&id=527823b7&scoped=true"
import script from "./star-open.vue?vue&type=script&lang=js"
export * from "./star-open.vue?vue&type=script&lang=js"

import "./star-open.vue?vue&type=style&index=0&id=527823b7&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527823b7"]])

export default __exports__